export { default } from "./RightPanel";
